import React from "react";

// Keep translated sentences intact. Only spoken cues, measurements and an
// optional note label receive emphasis; no translated HTML is injected.
export default function InstructionText({
  text = "",
  label = false,
  warning = false,
}) {
  const prefix = label
    ? text.match(/^.*?[:：]/)?.[0]
    : warning
      ? text.split(/[（(]/)[0]
      : "";
  const body = prefix ? text.slice(prefix.length) : text;
  const parts = body.split(
    /(“[^”]+”|「[^」]+」|«[^»]+»|\d+(?:[–〜-]\d+)?\s*(?:seconds?|secondes?|segundos?|minutes?|s\b|m\b|ft\b|pieds\b|pies\b|футов|секунд|秒|米|メートル|分|×))/gu,
  );
  return (
    <>
      {prefix && <strong>{prefix}</strong>}
      {parts.map((part, index) =>
        index % 2 ? <strong key={index}>{part}</strong> : part,
      )}
    </>
  );
}
